import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DailyLegLoadGraphFilters, DailyLegLoadGraphModel } from '../../models/daily-leg-loads/daily-leg-load.models';
import { AppConfig } from '../../app/app.config';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';

@Injectable()
export class DailyLegLoadGraphService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private dateParserService: DateParserService,
  ) {
  }

  getDailyLoadGraphData(filters: DailyLegLoadGraphFilters): Promise<DailyLegLoadGraphModel> {
    filters = this.dateParserService.removeOffsetFromLuxonDates(filters);

    const url = `${this.config.apiUrl}api/dailylegload/getgraphdata`;

    return this.http
      .post<DailyLegLoadGraphModel>(url, filters)
      .toPromise()
      .then((data: DailyLegLoadGraphModel) => {
        return data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/daily-leg-loads/daily-leg-load-graph.service.ts